import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch } from "../../store";
import PageLayout from "../../components/shared/PageLayout";
import ContactSettings from "../../components/settings/ContactSettings";
import TextareaSections from "../../components/settings/TextareaSections";
import { StyledSettings } from "./index.styled";
import {
  extractAndSaveToken,
  extractAndSaveStatusId,
  updateContactField,
  fetchStatusConnections,
} from "../../utils/apiService";
import UploadImage from "../../components/settings/UploadImage";
import LinksSettings from "../../components/settings/LinksSettings";
import EmailSettings from "../../components/settings/EmailSettings";
import {
  fetchTriggersDataAction,
  fetchStatusMeAction,
} from "../../store/dashboardSlice";
import SettingsLoadingSkeleton from "../../components/settings/SettingsLoadingSkeleton";
import type { RootState } from "../../store";
import type { DashboardState } from "../../types/dashboard";
import TokenInputComponent from "../../components/settings/TokenInput";
import StatusIdInputComponent from "../../components/settings/StatusIdInput";
import LogoutButton from "../../components/settings/LogoutButton";

const Settings = () => {
  const [connectionsData, setConnectionsData] = useState<{
    success: boolean;
    message: string;
    data: Array<{
      ID: number;
      UpdatedAt: string;
      DeletedAt: string | null;
      id: string;
      state: string;
      email: string;
      status_id: number;
      CreatedAt: string;
    }>;
  } | null>(null);
  const dispatch = useDispatch<AppDispatch>();
  const { status, loadingAll, triggersLoading } = useSelector(
    (state: RootState): DashboardState => state.dashboard
  );

  useEffect(() => {
    const loadSettingsData = async () => {
      try {
        extractAndSaveToken();
        extractAndSaveStatusId();

        dispatch(fetchStatusMeAction());

        dispatch(fetchTriggersDataAction());
      } catch (error) {
        console.error("Failed to load settings data:", error);
      }
    };

    loadSettingsData();
  }, [dispatch]);

  useEffect(() => {
    const fetchConnections = async () => {
        try {
          console.log("Fetching connections");
          const data = await fetchStatusConnections();
          console.log("Status connections data:", data);
          setConnectionsData(data);
        } catch (error) {
          console.error("Error fetching status connections:", error);
        }
    };

    fetchConnections();
  }, [status?.id]);

  const isLoading = loadingAll || triggersLoading;

  return (
    <PageLayout
      title="הגדרות חשבון"
      StyledComponent={StyledSettings}
      wrapInContainer={false}
    >
      {isLoading ? (
        <SettingsLoadingSkeleton />
      ) : (
        <div className="settings-container">
          {import.meta.env.DEV && <TokenInputComponent />}
          {import.meta.env.DEV && <StatusIdInputComponent />}
          <ContactSettings />
          <UploadImage />
          <TextareaSections
            statusDescription={status?.description || ""}
            replyMessage={status?.response_message || ""}
            onStatusDescriptionChange={async (value) => {
              if (status?.id) {
                try {
                  await updateContactField(status.id, "description", value);
                  dispatch(fetchStatusMeAction());
                } catch (error) {
                  console.error("Error updating status description:", error);
                }
              }
            }}
            onReplyMessageChange={async (value) => {
              if (status?.id) {
                try {
                  await updateContactField(
                    status.id,
                    "response_message",
                    value
                  );
                  dispatch(fetchStatusMeAction());
                } catch (error) {
                  console.error("Error updating response message:", error);
                }
              }
            }}
          />
          <LinksSettings />
          <EmailSettings connectionsData={connectionsData ?? undefined} />
          <LogoutButton />
        </div>
      )}
    </PageLayout>
  );
};

export default Settings;
